module.exports = __webpack_public_path__ + "static/media/it.1c09d574.png";